import { produce } from 'immer';
import { AppState } from './interface';
import { Actions } from './action';
import { AppAction } from './enum';

export const initialState: AppState = {
    isLoading: false,
    error: undefined,
    product: undefined,
};

const appReducer = (state = initialState, action: Actions) => {
    return produce(state, (draftState) => {
        switch (action.type) {
            case AppAction.SET_LOADING:
                draftState.isLoading = action.isLoading;
                break;
            case AppAction.SET_ERROR:
                draftState.error = action.error;
                break;
            case AppAction.SET_PRODUCT_DETAILS:
                draftState.product = action.product;
                break;
        }
    });
};

export default appReducer;
